<template>
  <ColumnsEffect>
    <div
      v-for="domain of items"
      :key="domain.uid"
      class="column is-3 is-marginless is-paddingless"
      @contextmenu.prevent="$emit('menu', { e: $event, domain: domain })"
    >
      <router-link v-if="!domain.edit" :to="`/domains/${domain.uid}`">
        <span class="icon">
          <i class="mdi mdi-domain" aria-hidden="true"></i>
        </span>

        <span>{{ domain.friendlyName }}</span>

        <span v-if="domain.shared" class="icon" data-tooltip="Shared with you">
          <i class="mdi mdi-share-variant"></i>
        </span>

        <span
          v-if="!domain.shared && domain.sharedWithOthers"
          class="icon"
          data-tooltip="Shared with others"
        >
          <i class="mdi mdi-account-multiple-plus"></i>
        </span>
      </router-link>

      <EditSingleField
        v-if="domain.edit"
        :text="domain.friendlyName"
        validation="required"
        type="text"
        name="name"
        @save="$emit('save', { domain: domain, text: $event })"
        @cancel="$emit('cancel', domain)"
        :isLoading="domain.saving"
      ></EditSingleField>
    </div>
  </ColumnsEffect>
</template>

<script>
import permissions from "@/utils/permission.js";

export default {
  props: { items: Array },
  components: {
    ColumnsEffect: () => import("@/components/singles/ColumnsEffect.vue"),

    EditSingleField: () =>
      import("@/components/singles/EditSingleField/component.vue"),
  },
  computed: {
    permission() {
      return (domain) => {
        if (domain.permission) return permissions.domain[domain.permission];
        else return "Owner";
      };
    },
  },
};
</script>
